import { SVGProps } from 'react';

export default function InstructionsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M8.0403 16.1354C12.4245 16.1354 16.0432 12.5211 16.0432 8.13538C16.0432 3.74962 12.4186 0.135376 8.03447 0.135376C3.65503 0.135376 0.0432129 3.74962 0.0432129 8.13538C0.0432129 12.5211 3.66084 16.1354 8.0403 16.1354ZM6.61468 12.5342C6.22499 12.5342 5.92858 12.2603 5.92858 11.8594C5.92858 11.4961 6.22499 11.1991 6.61468 11.1991H7.53783V8.09887H6.7578C6.37688 8.09887 6.07466 7.82206 6.07466 7.42404C6.07466 7.05961 6.37688 6.76373 6.7578 6.76373H8.29975C8.78921 6.76373 9.04633 7.10583 9.04633 7.62211V11.1991H9.86108C10.2439 11.1991 10.5472 11.4961 10.5472 11.8594C10.5472 12.2603 10.2439 12.5342 9.86108 12.5342H6.61468ZM8.01086 5.59032C7.38339 5.59032 6.86856 5.07058 6.86856 4.44576C6.86856 3.80084 7.38339 3.29908 8.01086 3.29908C8.63831 3.29908 9.13978 3.80084 9.13978 4.44576C9.13978 5.07058 8.63831 5.59032 8.01086 5.59032Z"
        fill="inherit"
      />
    </svg>
  );
}
